import React from "react";
import { Form } from "antd";

function RowInput({ box, text, required, name, children, className, ...props }) {
  return <Form.Item label={name} className={className}>{children}</Form.Item>;
}

export default RowInput;
